"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Dir = _interopRequireDefault(require("../model/Dir"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Hifs service.
* @module api/HifsApi
* @version 1.0.0
*/
var HifsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new HifsApi. 
  * @alias module:api/HifsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function HifsApi(apiClient) {
    _classCallCheck(this, HifsApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the copy operation.
   * @callback module:api/HifsApi~copyCallback
   * @param {String} error Error message, if any.
   * @param data This operation does not return a value.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 复制文件或目录
   * 复制文件或目录, 如果所需的上层路径不存在则自动创建
   * @param {String} src 源路径
   * @param {String} dst 目的路径
   * @param {module:api/HifsApi~copyCallback} callback The callback function, accepting three arguments: error, data, response
   */


  _createClass(HifsApi, [{
    key: "copy",
    value: function copy(src, dst, callback) {
      var postBody = null; // verify the required parameter 'src' is set

      if (src === undefined || src === null) {
        throw new Error("Missing the required parameter 'src' when calling copy");
      } // verify the required parameter 'dst' is set


      if (dst === undefined || dst === null) {
        throw new Error("Missing the required parameter 'dst' when calling copy");
      }

      var pathParams = {};
      var queryParams = {
        'src': src,
        'dst': dst
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/copy', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteDir operation.
     * @callback module:api/HifsApi~deleteDirCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 删除目录
     * 删除目录, 如果该目录下有文件和目录则递归删除, 如果目录不存在则直接返回成功
     * @param {String} path 需要删除的目录的完整路径
     * @param {module:api/HifsApi~deleteDirCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "deleteDir",
    value: function deleteDir(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling deleteDir");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/dir', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteFile operation.
     * @callback module:api/HifsApi~deleteFileCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 删除文件
     * 删除文件, 如果文件不存在同样返回成功
     * @param {String} path 需要删除的文件的完整路径
     * @param {module:api/HifsApi~deleteFileCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "deleteFile",
    value: function deleteFile(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling deleteFile");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/file', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getDir operation.
     * @callback module:api/HifsApi~getDirCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 返回一个目录及该目录下的文件
     * 只返回该目录及目录下第一层的文件和子目录, 不进行递归处理
     * @param {String} path 需要获取的目录的完整路径
     * @param {module:api/HifsApi~getDirCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "getDir",
    value: function getDir(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getDir");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getDirRecursiveData operation.
     * @callback module:api/HifsApi~getDirRecursiveDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 递归获取目录下的所有文件及其数据
     * 递归获取目录下的所有文件的元数据, 包含文件的实际数据, 文件的实际数据包含在文件的 Data 字段, 由于可能包含的数据较多, 一般用于文件和目录较多但每个文件都很小的场景
     * @param {String} path 需要获取的目录的完整路径
     * @param {module:api/HifsApi~getDirRecursiveDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "getDirRecursiveData",
    value: function getDirRecursiveData(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getDirRecursiveData");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir/recursive/data', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getDirRecursiveMetadata operation.
     * @callback module:api/HifsApi~getDirRecursiveMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 递归获取目录下的所有文件的元数据
     * 递归获取目录下的所有文件的元数据, 不包含文件的实际数据, 文件的 Data 字段为空
     * @param {String} path 需要获取的目录的完整路径
     * @param {module:api/HifsApi~getDirRecursiveMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "getDirRecursiveMetadata",
    value: function getDirRecursiveMetadata(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getDirRecursiveMetadata");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir/recursive/metadata', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getDirSubs operation.
     * @callback module:api/HifsApi~getDirSubsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 返回一个目录及该目录下的文件, 并获取该目录的直接子目录下的目录和文件
     * 只递归处理一层, 返回该目录及其直接子目录的内容
     * @param {String} path 需要获取的目录的完整路径
     * @param {module:api/HifsApi~getDirSubsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "getDirSubs",
    value: function getDirSubs(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getDirSubs");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir/subs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getDirSubsData operation.
     * @callback module:api/HifsApi~getDirSubsDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 返回一个目录及该目录下的文件(包含文件实际数据), 并获取该目录的直接子目录下的目录和文件(子目录下的文件不包含实际数据)
     * 只递归处理一层, 返回该目录及其直接子目录的内容, 赶回的该目录下的直接文件包含文件的实际数据, 文件的实际数据放在文件的 Data 字段, 子目录下的文件不包含文件的实际数据
     * @param {String} path 需要获取的目录的完整路径
     * @param {module:api/HifsApi~getDirSubsDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "getDirSubsData",
    value: function getDirSubsData(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getDirSubsData");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir/subs/data', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getFile operation.
     * @callback module:api/HifsApi~getFileCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取文件
     * 获取文件的实际数据
     * @param {String} path 需要获取的文件的完整路径
     * @param {module:api/HifsApi~getFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */

  }, {
    key: "getFile",
    value: function getFile(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getFile");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/octet-stream'];
      var returnType = File;
      return this.apiClient.callApi('/file', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getFileData operation.
     * @callback module:api/HifsApi~getFileDataCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取文件数据
     * 获取文件的实际数据
     * @param {String} path 需要获取的文件的完整路径
     * @param {module:api/HifsApi~getFileDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */

  }, {
    key: "getFileData",
    value: function getFileData(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getFileData");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/octet-stream'];
      var returnType = File;
      return this.apiClient.callApi('/file/data', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getPath operation.
     * @callback module:api/HifsApi~getPathCallback
     * @param {String} error Error message, if any.
     * @param {Boolean} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 检查路径是否存在
     * 检查路径是否存在
     * @param {String} path 要检查的路径
     * @param {module:api/HifsApi~getPathCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Boolean}
     */

  }, {
    key: "getPath",
    value: function getPath(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling getPath");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';
      return this.apiClient.callApi('/path', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postDir operation.
     * @callback module:api/HifsApi~postDirCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 新建目录
     * 新建目录
     * @param {String} path 需要创建的目录的完整路径
     * @param {module:api/HifsApi~postDirCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "postDir",
    value: function postDir(path, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling postDir");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postDirRecursiveData operation.
     * @callback module:api/HifsApi~postDirRecursiveDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Dir} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 使用 [GET] /dir/recursive/data 的数据在服务端反向构建目录和文件
     * 使用 [GET] /dir/recursive/data 的数据在服务端反向构建目录和文件, 文件创建时间和修改时间会发生变化
     * @param {String} path 需要还原的目录路径, 该目录必须不存在, 由接口调用在构建目录和文件时自动创建, 上层目录如果不存在则会自动创建
     * @param {module:model/Dir} data 来自 [GET] /dir/recursive/data 的数据, 用以在服务端反向构建目录和文件
     * @param {module:api/HifsApi~postDirRecursiveDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Dir}
     */

  }, {
    key: "postDirRecursiveData",
    value: function postDirRecursiveData(path, data, callback) {
      var postBody = data; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling postDirRecursiveData");
      } // verify the required parameter 'data' is set


      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling postDirRecursiveData");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Dir["default"];
      return this.apiClient.callApi('/dir/recursive/data', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postFile operation.
     * @callback module:api/HifsApi~postFileCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 上传文件
     * 上传文件到服务端，如果文件已存在则更新文件，不存在则创建文件，如果上层目录不存在同样会自动创建
     * @param {String} path 需要更新的文件的完整路径
     * @param {File} data file data
     * @param {module:api/HifsApi~postFileCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "postFile",
    value: function postFile(path, data, callback) {
      var postBody = null; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling postFile");
      } // verify the required parameter 'data' is set


      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling postFile");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {
        'data': data
      };
      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/file', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postFileData operation.
     * @callback module:api/HifsApi~postFileDataCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 通过文件数据创建/更新文件
     * 上传文件的数据到服务端，服务端根据文件内容创建实际的文件, 如果文件已存在则更新文件，不存在则创建文件，如果上层目录不存在同样会自动创建
     * @param {String} path 需要更新的文件的完整路径
     * @param {String} data file data
     * @param {module:api/HifsApi~postFileDataCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "postFileData",
    value: function postFileData(path, data, callback) {
      var postBody = data; // verify the required parameter 'path' is set

      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling postFileData");
      } // verify the required parameter 'data' is set


      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling postFileData");
      }

      var pathParams = {};
      var queryParams = {
        'path': path
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/file/data', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the rename operation.
     * @callback module:api/HifsApi~renameCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 重命名/移动文件或目录
     * 重命名/移动文件或目录, 如果所需的上层路径不存在则自动创建
     * @param {String} src 源路径
     * @param {String} dst 目的路径
     * @param {module:api/HifsApi~renameCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "rename",
    value: function rename(src, dst, callback) {
      var postBody = null; // verify the required parameter 'src' is set

      if (src === undefined || src === null) {
        throw new Error("Missing the required parameter 'src' when calling rename");
      } // verify the required parameter 'dst' is set


      if (dst === undefined || dst === null) {
        throw new Error("Missing the required parameter 'dst' when calling rename");
      }

      var pathParams = {};
      var queryParams = {
        'src': src,
        'dst': dst
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/rename', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return HifsApi;
}();

exports["default"] = HifsApi;